module.exports = __webpack_public_path__ + "img/75723.a0677348.svg";